import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from "@app/core";
import { BsModalRef } from "ngx-bootstrap";
import { JobViewService } from "@app/features/customers/customer/jobs-view/service/job-view-service";
import { Subject } from "rxjs";
var JobPartEditComponent = /** @class */ (function () {
    function JobPartEditComponent(fb, authService, sidePanelModalRef, jobViewService) {
        this.fb = fb;
        this.authService = authService;
        this.sidePanelModalRef = sidePanelModalRef;
        this.jobViewService = jobViewService;
        this.jobType = 0;
        this.PurchaseOrderReadaccess = false;
        this.jobtodos = 0;
        this.moduleId = 3;
        this.partStatus = 'edit_requested';
        this.showCostPrice = true;
        this.showQuantity = true;
    }
    JobPartEditComponent.prototype.ngOnInit = function () {
        if (this.partStatus == 'edit_all' && (this.sidepanelData.Status == 'On Order' || this.sidepanelData.Status == "Available" || this.sidepanelData.Status == "Installed" || this.sidepanelData.Status == "Picked up")) {
            this.partStatus = 'edit_ordered';
        }
        else if (this.partStatus == 'edit_all' && this.sidepanelData.Status == 'Requested') {
            this.partStatus = 'edit_requested';
        }
        this.onClose = new Subject();
        this.PurchaseOrderReadaccess = this.authService.permitted(['Purchaseorder.readaccess']) === true;
        var quantityVal = this.normalizeNumber(this.sidepanelData.Quantity);
        var costPriceVal = this.sidepanelData['Unit cost price'] == '0' ? 0 : this.normalizeNumber(this.sidepanelData['Unit cost price']);
        var salePriceVal = this.sidepanelData['Unit sales price'] == '0' ? 0 : this.normalizeNumber(this.sidepanelData['Unit sales price']);
        this.form = this.fb.group({
            Quantity: [quantityVal !== undefined && quantityVal !== null ? quantityVal : '', [Validators.required, Validators.min(1)]],
            costprice: [costPriceVal !== undefined && costPriceVal !== null ? costPriceVal : '', [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/)]],
            saleprice: [salePriceVal !== undefined && salePriceVal !== null ? salePriceVal : '', [Validators.required, Validators.pattern(/^\d+(\.\d+)?$/)]]
        });
        if ((this.partStatus == 'edit_ordered' || this.partStatus == 'edit_available' || this.partStatus === "edit_installed" || this.partStatus === "edit_pickUp") && this.sidepanelData['FulfillType'] != 'General') {
            this.showCostPrice = false;
        }
        if (this.partStatus == 'edit_ordered' || this.partStatus == 'edit_available' || this.partStatus === "edit_installed" || this.partStatus === "edit_pickUp") {
            this.showQuantity = false;
        }
    };
    Object.defineProperty(JobPartEditComponent.prototype, "f", {
        get: function () { return this.form.controls; },
        enumerable: true,
        configurable: true
    });
    JobPartEditComponent.prototype.normalizeNumber = function (value) {
        if (value === undefined || value === null || value === '')
            return value;
        var str = String(value).trim();
        str = str.replace(/[\s,]/g, '');
        if (str.includes('.')) {
            var parts = str.split('.');
            if (parts.length > 2) {
                str = parts.slice(0, -1).join('') + '.' + parts.slice(-1);
            }
        }
        return Number(str);
    };
    JobPartEditComponent.prototype.onSave = function () {
        var _this = this;
        if (this.form.invalid)
            return;
        var quantity = this.normalizeNumber(this.form.get('Quantity').value);
        var costprice = this.normalizeNumber(this.form.get('costprice').value);
        var salesprice = this.normalizeNumber(this.form.get('saleprice').value);
        var id = this.sidepanelData['id'];
        var fulfillType = this.sidepanelData['FulfillType'];
        var partStatus = this.sidepanelData['Status'];
        var jobId = this.sidepanelData['jobId'] != null ? this.sidepanelData['jobId'] : this.sidepanelData['jobid'];
        var moduleId = this.moduleId;
        var jobtodos = this.jobtodos;
        var saveData = { quantity: quantity, costprice: costprice, salesprice: salesprice, id: id, fulfillType: fulfillType, partStatus: partStatus, jobId: jobId, moduleId: moduleId, jobtodos: jobtodos };
        this.jobViewService.saveEditPart(saveData).subscribe(function (response) {
            _this.onClose.next(true);
        });
    };
    return JobPartEditComponent;
}());
export { JobPartEditComponent };
